export default __webpack_public_path__ + "static/media/health_check_3x2_Hk.ea5ce95e.webp";